import {
	type BettingInsightsSortConfig,
	type EsIndex,
} from '~/configuration/betting-insights/types';

export function convertSortingConfigToSortingValue<TIndex extends EsIndex>({
	field,
	order,
}: BettingInsightsSortConfig<TIndex>): string {
	return `_${field}_${order}`;
}
